import { InternalAxiosRequestConfig } from 'axios';
import { isMixpanelReady } from 'src/libs/analytics/src/mixpanel';

/**
 * Header the backends read to decide whether to mirror a user action to
 * Mixpanel server-side. Listing-review must allowlist it in CORS
 * (`src/common/configs/cors.config.ts` there) or the browser rejects every
 * request carrying it at preflight.
 */
export const ANALYTICS_CONSENT_HEADER = 'x-analytics-consent';

export type AnalyticsConsentValue = 'granted' | 'denied';

/**
 * Mirrors the frontend's own client-side gate: Mixpanel is only initialised
 * once the user accepts analytics cookies, so `isMixpanelReady()` is the single
 * source of truth for consent.
 */
export const analyticsConsentValue = (): AnalyticsConsentValue => (isMixpanelReady() ? 'granted' : 'denied');

/**
 * Attaches the consent header to an outgoing request.
 *
 * **Every** HTTP client that talks to listing-review must call this. The backend
 * gate is `request.headers['x-analytics-consent'] === 'granted'`, so a client
 * that omits the header silently reads as "denied" and suppresses tracking
 * rather than failing loudly.
 */
export function attachAnalyticsConsentHeader<T extends InternalAxiosRequestConfig>(config: T): T {
  config.headers = config.headers || {};
  config.headers[ANALYTICS_CONSENT_HEADER] = analyticsConsentValue();
  return config;
}
